import { mutator } from 'satcheljs';
import getStore from '../store/store';
import initializeSettings from '../actions/initializeSettings';

/**
 * Initializes the personal booking page settings in the store.
 */
export default mutator(initializeSettings, actionMessage => {
    let store = getStore();
    store.publishingSettings = actionMessage.pbpSettings.PublishingSettings;
    store.isAnonymousSharingEnabled = actionMessage.pbpSettings.IsAnonymousSharingAllowed;
});
